import dynamic from "next/dynamic";

const UserGuideTooltip = dynamic(import("./userGuideTooltip"), { ssr: false });

export default UserGuideTooltip;
